import { Suspense } from "react";
import { useTranslation } from "@i18n/hooks";
import { BaseScreen } from "../../components/base-screen";
import { NoAccess } from "../../components/no-access";
import { UsersTable } from "../../features/users/users-table";
import { useHasPermissions } from "../../hooks/use-has-permissions";

export const UsersScreen = () => {
	const { t } = useTranslation("common");
	const canRead = useHasPermissions(["UserInAccountPermission_AuthAdmin_Read"]);

	if (!canRead) return <NoAccess />;

	return (
		<BaseScreen title={t("users.title")}>
			<Suspense fallback={<div>{t("general.loading")}</div>}>
				<UsersTable />
			</Suspense>
		</BaseScreen>
	);
};
